<div class="{{ className }}">
  <label [attr.for]="effectiveInputId" [attr.id]="effectiveInputId + '-a11y-label'">{{ defaultMessageContent | translate }}</label>
  @if (form) {
    <app-auto-complete
      (selectedItemChange)="onSelectChangeUser($event)"
      (removeItemChange)="onRemoveItemChange($event)"
      (searchChange)="onSearchChangeStudent($event)"
      [itemsData]="students"
      [selectedItem]="form.get(controlName)?.value"
      [multiple]="multiple"
      [inputId]="effectiveInputId"
      [labelElementId]="effectiveInputId + '-a11y-label'"
      [ariaLabel]="(defaultMessageContent | translate)"
    ></app-auto-complete>
  }
</div>
